import { Component } from "solid-js"

interface SaveBeforeLoadModalProps {
    isOpen: boolean
    onSave?: () => void
    onDiscard?: () => void
    onCancel: () => void
    title?: string
    message?: string
    simpleMode?: boolean
}

const SaveBeforeLoadModal: Component<SaveBeforeLoadModalProps> = (props) => {
    return (
        <>
            {props.isOpen && (
                <div class="bg-opacity-50 fixed inset-0 z-[10000] flex items-center justify-center">
                    <div class="mx-4 w-full max-w-md rounded-lg bg-white shadow-xl">
                        <div class="p-6">
                            <h2 class="mb-4 text-xl font-bold text-gray-900">
                                {props.title || "Spara ditt nuvarande scenario?"}
                            </h2>
                            <p class="mb-6 text-sm text-gray-600">
                                {props.message ||
                                    "Du har ett osparat anpassat scenario. Vill du dela och spara det innan du laddar det nya scenariot?"}
                            </p>
                            {props.simpleMode ? (
                                <div class="flex justify-end">
                                    <button
                                        onClick={props.onCancel}
                                        class="rounded-lg bg-blue-600 px-4 py-3 font-medium text-white transition-colors hover:bg-blue-700"
                                    >
                                        OK
                                    </button>
                                </div>
                            ) : (
                                <div class="flex flex-col gap-3">
                                    <button
                                        onClick={props.onSave}
                                        class="w-full rounded-lg bg-blue-600 px-4 py-3 font-medium text-white transition-colors hover:bg-blue-700"
                                    >
                                        Ja, dela och spara länk
                                    </button>
                                    <button
                                        onClick={props.onDiscard}
                                        class="w-full rounded-lg bg-red-600 px-4 py-3 font-medium text-white transition-colors hover:bg-red-700"
                                    >
                                        Nej, skriv över
                                    </button>
                                    <button
                                        onClick={props.onCancel}
                                        class="w-full rounded-lg bg-gray-200 px-4 py-3 font-medium text-gray-900 transition-colors hover:bg-gray-300"
                                    >
                                        Avbryt
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default SaveBeforeLoadModal
